import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--custom-form-raw-data"
export default class extends Controller {
  static targets = ["customForm"];
  static values = { customFormsUrl: String };

  connect() {
    this.customFormSelect = new TomSelect(this.customFormTarget, {
      valueField: "id",
      labelField: "title",
      searchField: "title",
      preload: true,
      load: (query, callback) => {
        const url = new URL(this.customFormsUrlValue, window.location.origin);
        if (query) url.searchParams.set("q", query);

        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            callback(json);
          })
          .catch(() => {
            callback();
          });
      },
    });
  }
}
